import React from 'react';
// src/pages/LoginPage.jsx - Page de connexion complète
import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuthStore } from '../store';
import { authAPI } from '../services/api';
import toast from 'react-hot-toast';
import { useLang } from '../i18n/i18n';

const S = {
  page: {
    minHeight: '100vh', background: '#0A0E1A',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Sora', sans-serif", padding: '20px',
  },
  card: {
    width: '100%', maxWidth: 420,
    background: '#111827',
    border: '1px solid #1e2d45',
    borderRadius: 24, padding: '40px 36px',
    boxShadow: '0 0 60px #00d4aa15',
  },
  logo: { fontSize: 32, fontWeight: 800, color: '#00D4AA', letterSpacing: '-1px', textAlign: 'center', marginBottom: 4 },
  subtitle: { fontSize: 13, color: '#6b7fa3', textAlign: 'center', marginBottom: 32 },
  label: { fontSize: 12, fontWeight: 600, color: '#6b7fa3', display: 'block', marginBottom: 6, letterSpacing: 0.5 },
  input: {
    width: '100%', background: '#1a2235',
    border: '1px solid #1e2d45', borderRadius: 12,
    padding: '12px 16px', color: '#E8EDF5',
    fontSize: 14, outline: 'none',
    fontFamily: "'Sora', sans-serif",
    boxSizing: 'border-box', transition: 'border-color 0.2s',
  },
  group: { marginBottom: 16 },
  btn: {
    width: '100%', padding: '14px',
    background: 'linear-gradient(90deg, #00D4AA, #00b894)',
    border: 'none', borderRadius: 12,
    color: '#000', fontWeight: 800, fontSize: 15,
    cursor: 'pointer', fontFamily: "'Sora', sans-serif",
    boxShadow: '0 0 24px #00d4aa44', marginTop: 8,
    transition: 'opacity 0.2s',
  },
  link: { color: '#00D4AA', textDecoration: 'none', fontWeight: 600 },
  footer: { textAlign: 'center', marginTop: 20, fontSize: 13, color: '#6b7fa3' },
  error: { background: '#ff4f6a15', border: '1px solid #ff4f6a44', borderRadius: 10, padding: '10px 14px', color: '#ff4f6a', fontSize: 13, marginBottom: 16 },
};

export function LoginPage() {
  const { t } = useLang();
  const [form, setForm] = useState({ phone: '+237', password: '', username: '', display_name: '', confirm: '' });
  const [indicatif, setIndicatif] = useState('+237');
  const [showCountries, setShowCountries] = useState(false);
  const [usePhone, setUsePhone] = useState(true);
  const [showPwd, setShowPwd] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);
  const [step, setStep] = useState('login'); // login | 2fa | verify-phone | forgot | reset
  const [resetPhone, setResetPhone] = useState('');
  const [resetOtp, setResetOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
  const [tempToken, setTempToken] = useState('');
  const [totpCode, setTotpCode] = useState('');
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const { login, isLoading } = useAuthStore();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    const result = await login(form, rememberMe);
    if (result.success) {
      navigate('/');
    } else if (result.requires2FA) {
      setTempToken(result.tempToken);
      setStep('2fa');
    } else if (result.error?.includes('non vérifié')) {
      setStep('verify-phone');
    } else {
      setError(result.error || 'Erreur de connexion');
    }
  };

  const handle2FA = async (e) => {
    e.preventDefault();
    try {
      const res = await authAPI.verify2FA({ tempToken, totp_code: totpCode });
      // L'intercepteur axios retourne response.data directement — res EST le body JSON
      const tokens = res.data || res;
      const { access_token, refresh_token, user } = tokens;
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('refresh_token', refresh_token);
      localStorage.setItem('user', JSON.stringify(user));
      useAuthStore.setState({ user, isAuthenticated: true });
      socketService.connect(access_token);
      navigate('/');
    } catch (err) {
      setError('Code 2FA incorrect');
    }
  };

  const handleVerifyPhone = async (e) => {
    e.preventDefault();
    try {
      await authAPI.verifyPhone({ phone: form.phone, otp });
      toast.success('Téléphone vérifié ! Connectez-vous.');
      setStep('login');
    } catch {
      setError('Code incorrect ou expiré');
    }
  };

  return (
    <div style={S.page}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&display=swap'); input:focus { border-color: #00D4AA !important; }`}</style>
      <div style={S.card}>
        <div style={{display:'flex',alignItems:'baseline',justifyContent:'center',marginBottom:4}}>
          <span style={{fontSize:32,fontWeight:800,color:'#00D4AA',letterSpacing:'-1px'}}>PAY</span>
          <span style={{fontSize:32,fontWeight:800,color:'#E8EDF5',letterSpacing:'-1px',position:'relative',left:-4}}>CHAT</span>
          <span style={{fontSize:11,color:'#6b7fa3',marginLeft:4}}>by ZENVOI</span>
        </div>
        <div style={S.subtitle}>Messagerie & Paiements sécurisés</div>

        {error && <div style={S.error}>⚠️ {error}</div>}

        {step === 'login' && (
          <form onSubmit={handleLogin}>
            <div style={S.group}>
              <label style={S.label}>TÉLÉPHONE / NOM D'UTILISATEUR</label>
              <div style={{display:'flex',gap:6,marginBottom:6}}>
                <div onClick={()=>setUsePhone(true)} style={{padding:'6px 12px',borderRadius:8,background:usePhone?'#00D4AA22':'transparent',border:`1px solid ${usePhone?'#00D4AA':'#1e2d45'}`,color:usePhone?'#00D4AA':'#6b7fa3',fontSize:12,cursor:'pointer',fontWeight:600}}>📱 Téléphone</div>
                <div onClick={()=>setUsePhone(false)} style={{padding:'6px 12px',borderRadius:8,background:!usePhone?'#00D4AA22':'transparent',border:`1px solid ${!usePhone?'#00D4AA':'#1e2d45'}`,color:!usePhone?'#00D4AA':'#6b7fa3',fontSize:12,cursor:'pointer',fontWeight:600}}>👤 Identifiant</div>
              </div>
              {usePhone ? (
                <div>
                  <div style={{position:'relative',marginBottom:8}}>
                    <div onClick={()=>setShowCountries(s=>!s)}
                      style={{...S.input,marginBottom:0,display:'flex',alignItems:'center',gap:8,cursor:'pointer'}}>
                      <span style={{fontSize:20}}>{COUNTRIES.find(c=>c.code===indicatif)?.flag}</span>
                      <span style={{color:'#E8EDF5',fontWeight:600}}>{indicatif}</span>
                      <span style={{color:'#6b7fa3',fontSize:13,flex:1}}>{COUNTRIES.find(c=>c.code===indicatif)?.name}</span>
                      <span style={{color:'#6b7fa3'}}>▾</span>
                    </div>
                    {showCountries && (
                      <div style={{position:'absolute',top:'100%',left:0,right:0,background:'#111827',border:'1px solid #1e2d45',borderRadius:10,maxHeight:200,overflowY:'auto',zIndex:100,marginTop:4}}>
                        {COUNTRIES.map(c=>(
                          <div key={c.code} onClick={()=>{setIndicatif(c.code);setShowCountries(false);}}
                            style={{display:'flex',alignItems:'center',gap:10,padding:'10px 14px',cursor:'pointer',borderBottom:'1px solid #1e2d4533',background:indicatif===c.code?'#00D4AA22':'transparent'}}>
                            <span style={{fontSize:18}}>{c.flag}</span>
                            <span style={{color:'#E8EDF5',fontSize:14}}>{c.name}</span>
                            <span style={{color:'#6b7fa3',fontSize:13,marginLeft:'auto'}}>{c.code}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <input style={{...S.input,marginBottom:0}} type="tel" placeholder="6XX XXX XXX"
                    value={form.phone.startsWith(indicatif) ? form.phone.slice(indicatif.length) : form.phone}
                    onChange={e=>{const n=e.target.value.replace(/[^0-9]/g,'');setForm({...form,phone:indicatif+n});}} required />
                </div>
              ) : (
                <input style={S.input} type="text" placeholder="nom_utilisateur ou email" value={form.phone}
                  onChange={e=>setForm({...form,phone:e.target.value})} required />
              )}
            </div>
            <div style={S.group}>
              <label style={S.label}>MOT DE PASSE</label>
              <div style={{position:'relative',display:'flex',alignItems:'center'}}>
                <input style={{...S.input,marginBottom:0,paddingRight:40}} type={showPwd?'text':'password'} {...{placeholder:'••••••••'}} value={form.password}
                  onChange={e => setForm({ ...form, password: e.target.value })} required />
                <button type="button" onClick={()=>setShowPwd(!showPwd)}
                  style={{position:'absolute',right:12,background:'none',border:'none',cursor:'pointer',fontSize:18,color:'#6b7fa3',padding:0}}>
                  {showPwd ? '🙈' : '👁️'}
                </button>
              </div>
            </div>
            <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:12,marginTop:4}}>
              <input
                type="checkbox"
                id="rememberMe"
                checked={rememberMe}
                onChange={e=>setRememberMe(e.target.checked)}
                style={{width:16,height:16,accentColor:'#00D4AA',cursor:'pointer'}}
              />
              <label htmlFor="rememberMe" style={{fontSize:13,color:'#6b7fa3',cursor:'pointer',userSelect:'none'}}>
                Se souvenir de moi
              </label>
            </div>
            <button style={{ ...S.btn, opacity: isLoading ? 0.7 : 1 }} disabled={isLoading}>
              {isLoading ? t('connecting') : t('login')}
            </button>
            <div style={{textAlign:'center',marginTop:14}}>
              <button type="button" onClick={()=>{setStep('forgot');setError('');}}
                style={{background:'none',border:'none',color:'#6b7fa3',fontSize:13,cursor:'pointer',textDecoration:'underline'}}>
                Mot de passe oublié ?
              </button>
            </div>
          </form>
        )}

        {step === 'forgot' && (
          <div>
            <p style={{color:'#6b7fa3',fontSize:13,marginBottom:20,lineHeight:1.6}}>
              📱 Entrez votre numéro de téléphone. Vous recevrez un code SMS pour réinitialiser votre mot de passe.
            </p>
            <div style={S.group}>
              <label style={S.label}>TÉLÉPHONE</label>
              <input style={S.input} type="tel" placeholder="+237612345678"
                value={resetPhone} onChange={e=>setResetPhone(e.target.value)}/>
            </div>
            <p style={{color:'#00D4AA',fontSize:11,marginTop:-12,marginBottom:12}}>
              Format international requis : +237612345678
            </p>
            <button style={S.btn} onClick={async()=>{
              let phone = resetPhone.trim();
              if (!phone) return setError('Numéro requis');
              if (phone.startsWith('6') || phone.startsWith('2')) phone = '+237' + phone;
              if (!phone.startsWith('+')) phone = '+' + phone;
              try {
                await authAPI.forgotPassword({ phone });
                setResetPhone(phone);
                toast.success('Code SMS envoyé !');
                setStep('reset');
                setError('');
              } catch(err) {
                setError(err.error || 'Numéro introuvable. Vérifiez le format : +237XXXXXXXXX');
              }
            }}>Envoyer le code SMS</button>
            <button type="button" onClick={()=>setStep('login')}
              style={{...S.btn,background:'transparent',border:'1px solid #1e2d45',color:'#6b7fa3',marginTop:8,boxShadow:'none'}}>
              ← Retour
            </button>
          </div>
        )}

        {step === 'reset' && (
          <div>
            <p style={{color:'#6b7fa3',fontSize:13,marginBottom:20,lineHeight:1.6}}>
              📱 Entrez le code reçu par SMS et votre nouveau mot de passe.
            </p>
            <div style={S.group}>
              <label style={S.label}>CODE SMS</label>
              <input style={{...S.input,fontSize:22,textAlign:'center',letterSpacing:8}}
                type="text" inputMode="numeric" maxLength={6} placeholder="000000"
                value={resetOtp} onChange={e=>setResetOtp(e.target.value.replace(/\D/g,''))}/>
            </div>
            <div style={S.group}>
              <label style={S.label}>NOUVEAU MOT DE PASSE</label>
              <input style={S.input} type="password" placeholder="Ex: Paychat2026"
                value={newPassword} onChange={e=>setNewPassword(e.target.value)}/>
            </div>
            <div style={S.group}>
              <label style={S.label}>CONFIRMER</label>
              <input style={S.input} type="password" placeholder="Répétez le mot de passe"
                value={newPasswordConfirm} onChange={e=>setNewPasswordConfirm(e.target.value)}/>
            </div>
            <button style={S.btn} onClick={async()=>{
              if (newPassword.length < 8) return setError('Minimum 8 caractères');
              if (!/[A-Z]/.test(newPassword)) return setError('Au moins une majuscule requise');
              if (!/[0-9]/.test(newPassword)) return setError('Au moins un chiffre requis');
              if (newPassword !== newPasswordConfirm) return setError('Les mots de passe ne correspondent pas');
              try {
                await authAPI.resetPassword({ phone: resetPhone, otp: resetOtp, password: newPassword });
                toast.success('✅ Mot de passe réinitialisé ! Connectez-vous.');
                setStep('login');
                setError('');
              } catch(err) {
                setError(err.error || 'Code incorrect ou expiré');
              }
            }}>Réinitialiser le mot de passe</button>
            <button type="button" onClick={()=>setStep('forgot')}
              style={{...S.btn,background:'transparent',border:'1px solid #1e2d45',color:'#6b7fa3',marginTop:8,boxShadow:'none'}}>
              ← Retour
            </button>
          </div>
        )}

        {step === '2fa' && (
          <form onSubmit={handle2FA}>
            <p style={{ color: '#6b7fa3', fontSize: 13, marginBottom: 20, lineHeight: 1.6 }}>
              🔐 Entrez le code à 6 chiffres de votre application d'authentification (Google Authenticator, Authy...)
            </p>
            <div style={S.group}>
              <label style={S.label}>CODE 2FA</label>
              <input style={{ ...S.input, fontSize: 24, textAlign: 'center', letterSpacing: 8 }}
                type="text" inputMode="numeric" maxLength={6} placeholder="000000"
                value={totpCode} onChange={e => setTotpCode(e.target.value.replace(/\D/g, ''))} required />
            </div>
            <button style={S.btn}>Vérifier</button>
            <button type="button" onClick={() => setStep('login')}
              style={{ ...S.btn, background: 'transparent', border: '1px solid #1e2d45', color: '#6b7fa3', marginTop: 8, boxShadow: 'none' }}>
              ← Retour
            </button>
          </form>
        )}

        {step === 'verify-phone' && (
          <form onSubmit={handleVerifyPhone}>
            <p style={{ color: '#6b7fa3', fontSize: 13, marginBottom: 20 }}>
              📱 Un code a été envoyé au {form.phone}
            </p>
            <div style={S.group}>
              <label style={S.label}>CODE SMS</label>
              <input style={{ ...S.input, fontSize: 24, textAlign: 'center', letterSpacing: 8 }}
                type="text" inputMode="numeric" maxLength={6} placeholder="000000"
                value={otp} onChange={e => setOtp(e.target.value.replace(/\D/g, ''))} required />
            </div>
            <button style={S.btn}>Vérifier mon numéro</button>
          </form>
        )}

        <div style={S.footer}>
          Pas encore de compte ? <span onClick={()=>window.location.href='/register'} style={{...S.link, cursor:'pointer'}}>S'inscrire</span>
        </div>
        <div style={{ ...S.footer, marginTop: 12, fontSize: 11 }}>
          🔒 Chiffrement end-to-end · PCI-DSS · 2FA
        </div>
      </div>
    </div>
  );
}

// ============================================
// PAGE D'INSCRIPTION
// ============================================
const COUNTRIES = [
  { code: '+237', flag: '🇨🇲', name: 'Cameroun' },
  { code: '+225', flag: '🇨🇮', name: "Côte d'Ivoire" },
  { code: '+221', flag: '🇸🇳', name: 'Sénégal' },
  { code: '+223', flag: '🇲🇱', name: 'Mali' },
  { code: '+226', flag: '🇧🇫', name: 'Burkina Faso' },
  { code: '+227', flag: '🇳🇪', name: 'Niger' },
  { code: '+228', flag: '🇹🇬', name: 'Togo' },
  { code: '+229', flag: '🇧🇯', name: 'Bénin' },
  { code: '+236', flag: '🇨🇫', name: 'Centrafrique' },
  { code: '+241', flag: '🇬🇦', name: 'Gabon' },
  { code: '+242', flag: '🇨🇬', name: 'Congo' },
  { code: '+243', flag: '🇨🇩', name: 'RD Congo' },
  { code: '+240', flag: '🇬🇶', name: 'Guinée Éq.' },
  { code: '+235', flag: '🇹🇩', name: 'Tchad' },
  { code: '+257', flag: '🇧🇮', name: 'Burundi' },
  { code: '+250', flag: '🇷🇼', name: 'Rwanda' },
  { code: '+261', flag: '🇲🇬', name: 'Madagascar' },
  { code: '+222', flag: '🇲🇷', name: 'Mauritanie' },
  { code: '+224', flag: '🇬🇳', name: 'Guinée' },
  { code: '+230', flag: '🇲🇺', name: 'Maurice' },
  { code: '+233', flag: '🇬🇭', name: 'Ghana' },
  { code: '+234', flag: '🇳🇬', name: 'Nigeria' },
  { code: '+33',  flag: '🇫🇷', name: 'France' },
  { code: '+32',  flag: '🇧🇪', name: 'Belgique' },
  { code: '+41',  flag: '🇨🇭', name: 'Suisse' },
  { code: '+1',   flag: '🇺🇸', name: 'USA/Canada' },
  { code: '+44',  flag: '🇬🇧', name: 'Royaume-Uni' },
  { code: '+49',  flag: '🇩🇪', name: 'Allemagne' },
  { code: '+34',  flag: '🇪🇸', name: 'Espagne' },
  { code: '+39',  flag: '🇮🇹', name: 'Italie' },
  { code: '+351', flag: '🇵🇹', name: 'Portugal' },
  { code: '+212', flag: '🇲🇦', name: 'Maroc' },
  { code: '+213', flag: '🇩🇿', name: 'Algérie' },
  { code: '+216', flag: '🇹🇳', name: 'Tunisie' },
  { code: '+20',  flag: '🇪🇬', name: 'Égypte' },
  { code: '+91',  flag: '🇮🇳', name: 'Inde' },
  { code: '+86',  flag: '🇨🇳', name: 'Chine' },
  { code: '+81',  flag: '🇯🇵', name: 'Japon' },
  { code: '+82',  flag: '🇰🇷', name: 'Corée du Sud' },
  { code: '+65',  flag: '🇸🇬', name: 'Singapour' },
  { code: '+971', flag: '🇦🇪', name: 'Émirats' },
  { code: '+966', flag: '🇸🇦', name: 'Arabie Saoudite' },
  { code: '+55',  flag: '🇧🇷', name: 'Brésil' },
  { code: '+52',  flag: '🇲🇽', name: 'Mexique' },
  { code: '+27',  flag: '🇿🇦', name: 'Afrique du Sud' },
  { code: '+254', flag: '🇰🇪', name: 'Kenya' },
  { code: '+256', flag: '🇺🇬', name: 'Ouganda' },
  { code: '+255', flag: '🇹🇿', name: 'Tanzanie' },
  { code: '+251', flag: '🇪🇹', name: 'Éthiopie' },
];

export function RegisterPage() {
  const t = (k) => k === 'login' ? 'Se connecter' : k;
  const [step, setStep] = useState('form'); // form | verify
  const [form, setForm] = useState({ phone: '+237', username: '', display_name: '', password: '', confirm: '' });
  const [indicatif, setIndicatif] = useState('+237');
  const [showCountries, setShowCountries] = useState(false);
  const [otp, setOtp] = useState('');
  const [showPwd, setShowPwd] = useState({password: false, confirm: false});
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendCountdown, setResendCountdown] = useState(60);
  const [resendChannel, setResendChannel] = useState('sms');
  const navigate = useNavigate();

  // Countdown renvoi OTP
  React.useEffect(() => {
    if (step !== 'verify') return;
    setResendCountdown(60);
    const t = setInterval(() => setResendCountdown(c => c > 0 ? c - 1 : 0), 1000);
    return () => clearInterval(t);
  }, [step]);

  const handleResendOtp = async (channel) => {
    setResendLoading(true); setError(''); setResendChannel(channel);
    try {
      await authAPI.resendOtp({ phone: form.phone, channel });
      toast.success(channel === 'sms' ? '📱 SMS renvoyé !' : channel === 'whatsapp' ? '💬 WhatsApp envoyé !' : '📧 Email envoyé !');
      setResendCountdown(60);
    } catch(e) {
      setError(e.error || 'Erreur lors du renvoi');
    } finally { setResendLoading(false); }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    // Validation complète
    if (!form.phone || form.phone.length < 8) return setError('Numéro de téléphone invalide. Vérifiez votre numéro.');
    if (!form.username || form.username.length < 3) return setError("Nom d'utilisateur trop court (minimum 3 caractères).");
    if (!/^[a-zA-Z0-9_]+$/.test(form.username)) return setError("Nom d'utilisateur: lettres, chiffres et _ uniquement. Pas d'espaces ni accents.");
    if (!form.display_name || form.display_name.length < 2) return setError('Prénom et nom requis (minimum 2 caractères).');
    if (form.password.length < 8) return setError('Le mot de passe doit contenir au moins 8 caractères.');
    if (form.password !== form.confirm) return setError('Les mots de passe ne correspondent pas. Vérifiez la confirmation.');
    setError(''); setLoading(true);
    try {
      await authAPI.register({ phone: form.phone, username: form.username, display_name: form.display_name, password: form.password });
      setStep('verify');
      toast.success('Compte créé ! Vérifiez votre téléphone.');
    } catch (err) {
      setError(err.error || 'Erreur lors de l\'inscription');
    } finally { setLoading(false); }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.verifyPhone({ phone: form.phone, otp });
      toast.success('✅ Compte vérifié !');
      navigate('/login');
    } catch {
      setError('Code incorrect ou expiré');
    } finally { setLoading(false); }
  };

  const fields = [
    { key: '_phone_custom', label: 'TÉLÉPHONE', type: 'tel', placeholder: '6XX XXX XXX' },
    { key: 'username', label: 'NOM D\'UTILISATEUR', type: 'text', placeholder: 'jean_dupont' },
    { key: 'display_name', label: 'PRÉNOM & NOM', type: 'text', placeholder: 'Jean Dupont' },
    { key: 'password', label: 'MOT DE PASSE', type: 'password', placeholder: 'Ex: MonChat2026' },
    { key: 'confirm', label: 'CONFIRMER', type: 'password', placeholder: 'Répétez le mot de passe' },
  ];

  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={{display:'flex',alignItems:'baseline',justifyContent:'center',marginBottom:4}}>
          <span style={{fontSize:32,fontWeight:800,color:'#00D4AA',letterSpacing:'-1px'}}>PAY</span>
          <span style={{fontSize:32,fontWeight:800,color:'#E8EDF5',letterSpacing:'-1px',position:'relative',left:-4}}>CHAT</span>
          <span style={{fontSize:11,color:'#6b7fa3',marginLeft:4}}>by ZENVOI</span>
        </div>
        <div style={S.subtitle}>Créer un compte gratuit</div>
        {error && <div style={S.error}>⚠️ {error}</div>}

        {step === 'form' ? (
          <form onSubmit={handleRegister}>
            {fields.map(f => (
              <div key={f.key} style={S.group}>
                <label style={S.label}>{f.label}</label>
                {f.key === '_phone_custom' ? (
                  <div>
                    {/* Sélecteur pays */}
                    <div style={{position:'relative',marginBottom:8}}>
                      <div onClick={()=>setShowCountries(s=>!s)}
                        style={{...S.input,marginBottom:0,display:'flex',alignItems:'center',gap:8,cursor:'pointer',userSelect:'none'}}>
                        <span style={{fontSize:20}}>{COUNTRIES.find(c=>c.code===indicatif)?.flag}</span>
                        <span style={{color:'#E8EDF5',fontWeight:600}}>{indicatif}</span>
                        <span style={{color:'#6b7fa3',fontSize:13,flex:1}}>{COUNTRIES.find(c=>c.code===indicatif)?.name}</span>
                        <span style={{color:'#6b7fa3'}}>▾</span>
                      </div>
                      {showCountries && (
                        <div style={{position:'absolute',top:'100%',left:0,right:0,background:'#111827',border:'1px solid #1e2d45',borderRadius:10,maxHeight:200,overflowY:'auto',zIndex:100,marginTop:4}}>
                          {COUNTRIES.map(c=>(
                            <div key={c.code} onClick={()=>{
                              setIndicatif(c.code);
                              setShowCountries(false);
                              setForm(f=>({...f, phone: c.code + f.phone.replace(/^\+\d+/, '')}));
                            }}
                              style={{display:'flex',alignItems:'center',gap:10,padding:'10px 14px',cursor:'pointer',borderBottom:'1px solid #1e2d4533',background:indicatif===c.code?'#00D4AA22':'transparent'}}>
                              <span style={{fontSize:18}}>{c.flag}</span>
                              <span style={{color:'#E8EDF5',fontSize:14}}>{c.name}</span>
                              <span style={{color:'#6b7fa3',fontSize:13,marginLeft:'auto'}}>{c.code}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    {/* Champ numéro */}
                    <input style={{...S.input,marginBottom:0}}
                      type="tel" placeholder={f.placeholder}
                      value={form.phone.startsWith(indicatif) ? form.phone.slice(indicatif.length) : form.phone}
                      onChange={e => {
                        const num = e.target.value.replace(/[^0-9]/g,'');
                        setForm({...form, phone: indicatif + num});
                      }} required />
                  </div>
                ) : (
                  <>
                  <div style={{position:'relative',display:'flex',alignItems:'center'}}>
                    <input style={{...S.input,marginBottom:0,paddingRight:40}}
                      type={f.type==='password'?(showPwd[f.key]?'text':'password'):f.type}
                      placeholder={f.placeholder}
                      value={form[f.key]} onChange={e => setForm({ ...form, [f.key]: e.target.value })} required />
                    {f.type==='password' && (
                      <button type="button" onClick={()=>setShowPwd({...showPwd,[f.key]:!showPwd[f.key]})}
                        style={{position:'absolute',right:12,background:'none',border:'none',cursor:'pointer',fontSize:18,color:'#6b7fa3',padding:0}}>
                        {showPwd[f.key] ? '🙈' : '👁️'}
                      </button>
                    )}
                  </div>
                  {f.key==='password' && (
                    <div style={{marginTop:6,fontSize:11,color: form.password.length===0?'#6b7fa3':form.password.length>=8?'#00D4AA':'#FF4F6A'}}>
                      {form.password.length===0 ? '8 caractères minimum requis' : form.password.length>=8 ? '✓ Longueur suffisante' : (form.password.length + '/8 caractères minimum')}
                    </div>
                  )}
                  </>
                )}
              </div>
            ))}
            <button style={{ ...S.btn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
              {loading ? 'Création...' : 'Créer mon compte'}
            </button>
            <div style={S.footer}>Déjà un compte ? <span onClick={()=>window.location.href='/login'} style={{...S.link,cursor:'pointer'}}>Se connecter</span></div>
          </form>
        ) : (
          <form onSubmit={handleVerify}>
            <p style={{ color: '#6b7fa3', fontSize: 13, marginBottom: 16 }}>
              📱 Code envoyé au <strong style={{color:'#E8EDF5'}}>{form.phone}</strong>
            </p>
            <div style={S.group}>
              <label style={S.label}>CODE DE VÉRIFICATION (6 chiffres)</label>
              <input style={{ ...S.input, fontSize: 24, textAlign: 'center', letterSpacing: 8 }}
                type="text" inputMode="numeric" maxLength={6} placeholder="000000"
                value={otp} onChange={e => setOtp(e.target.value.replace(/\D/g, ''))} />
            </div>
            <button style={S.btn} disabled={loading}>{loading ? 'Vérification...' : 'Vérifier mon compte'}</button>
            
            {/* Renvoi OTP */}
            <div style={{marginTop:20,textAlign:'center'}}>
              <p style={{fontSize:12,color:'#6b7fa3',marginBottom:10}}>Vous n'avez pas reçu le code ?</p>
              {resendCountdown > 0 ? (
                <p style={{fontSize:12,color:'#6b7fa3'}}>Renvoyer dans <strong style={{color:'#00D4AA'}}>{resendCountdown}s</strong></p>
              ) : (
                <div style={{display:'flex',flexDirection:'column',gap:8}}>
                  <button type="button" disabled={resendLoading} onClick={()=>handleResendOtp('sms')}
                    style={{padding:'10px',borderRadius:10,border:'1px solid #1e2d45',background:'#0D1526',color:'#E8EDF5',fontSize:13,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
                    📱 Renvoyer par SMS
                  </button>
                  <button type="button" disabled={resendLoading} onClick={()=>handleResendOtp('whatsapp')}
                    style={{padding:'10px',borderRadius:10,border:'1px solid #1e2d45',background:'#0D1526',color:'#25D366',fontSize:13,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
                    💬 Envoyer via WhatsApp
                  </button>
                  <button type="button" disabled={resendLoading} onClick={()=>handleResendOtp('email')}
                    style={{padding:'10px',borderRadius:10,border:'1px solid #1e2d45',background:'#0D1526',color:'#6b9fca',fontSize:13,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
                    📧 Envoyer par Email
                  </button>
                </div>
              )}
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
